import { render, staticRenderFns } from "./HotLineModal.vue?vue&type=template&id=58f0a0f2"
import script from "./HotLineModal.vue?vue&type=script&lang=js"
export * from "./HotLineModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports